const DEVICE_INFO_FIELDS = [
  'os',
  'hostname',
  'machine',
  'macSource',
  'macAddress',
  'cpuId',
  'hddSerial',
];

const parseDeviceInfo = (info) => {
  if (!info) return null;
  try {
    return typeof info === 'string' ? JSON.parse(info) : info;
  } catch {
    return null;
  }
};

export const getDeviceInfoValues = (info) => {
  const obj = parseDeviceInfo(info);
  if (!obj) return [];
  return DEVICE_INFO_FIELDS
    .filter((key) => obj[key] && key !== 'machineFingerprint')
    .map((key) => String(obj[key]));
};

export const formatDeviceInfoSummary = (info) => {
  const values = getDeviceInfoValues(info);
  if (values.length) return values.join(', ');
  if (typeof info === 'string' && info.trim()) {
    return info.length > 200 ? `${info.slice(0, 200)}…` : info;
  }
  return '-';
};

export const getDeviceHostname = (info) => {
  const obj = parseDeviceInfo(info);
  if (obj?.hostname) return String(obj.hostname);
  return '-';
};

export const getDeviceInfoDetailFields = (info) => {
  const obj = parseDeviceInfo(info);
  if (!obj) return null;
  return {
    os: obj.os || null,
    hostname: obj.hostname || null,
    machine: obj.machine || null,
    mac: obj.macAddress || obj.macSource || null,
    cpu: obj.cpuId || null,
    deviceId: obj.machineFingerprint || null,
  };
};

export const getRequestContactColumns = (request) => {
  if (request?.customer_type !== 'organisation') {
    return {
      clinic: request?.clinic_name?.trim() || '-',
      phone: request?.phone?.trim() || '-',
      city: request?.city?.trim() || '-',
    };
  }

  const contactFromRequest =
    request.client_name &&
    request.org_name &&
    request.client_name.trim().toLowerCase() !== request.org_name.trim().toLowerCase()
      ? request.client_name.trim()
      : null;

  const contact =
    request.org_contact_person?.trim() ||
    contactFromRequest ||
    null;

  const phone =
    request.phone?.trim() ||
    request.org_phone?.trim() ||
    null;

  const city =
    request.city?.trim() ||
    request.org_city?.trim() ||
    null;

  return {
    clinic: contact || '-',
    phone: phone || '-',
    city: city || '-',
  };
};

export const formatLicenseDeviceInfo = (license) => {
  if (license?.device_info) return formatDeviceInfoSummary(license.device_info);
  if (license?.mac_address) return license.mac_address;
  return '-';
};

export const formatLicenseActivationStatus = (license) => {
  if (!license?.device_id) return 'Not Activated';
  const obj = parseDeviceInfo(license.device_info);
  const mac = obj?.macAddress || license.mac_address;
  if (mac) return `Activated (${String(mac).toUpperCase()})`;
  return 'Activated';
};

export const getLicenseExpiryDate = (license) => {
  if (license?.expires_at) return new Date(license.expires_at);
  if (license?.device_id && license?.expiry_days) {
    const base = license.activated_at || license.created_at;
    if (base) {
      const date = new Date(base);
      date.setDate(date.getDate() + Number(license.expiry_days));
      return date;
    }
  }
  return null;
};

export const isLicenseExpired = (license) => {
  if (license?.status === 'expired') return true;
  if (!license?.device_id) return false;
  const expiryDate = getLicenseExpiryDate(license);
  return !!expiryDate && expiryDate.getTime() < Date.now();
};

export const formatLicenseExpiry = (license) => {
  const expiryDate = getLicenseExpiryDate(license);
  if (expiryDate) return expiryDate.toLocaleDateString();
  return '-';
};
